import styled from 'styled-components'

export const CardList = styled.ul`
  list-style: none;
`
export const CardItemStyled = styled.li`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  transition: 0.3s;
  :hover {
    span {
      font-weight: 600;
    }
  }
`
